// extracted by mini-css-extract-plugin
module.exports = {"hidden":"notice_hidden__5ZyE1","textEmphasis":"notice_textEmphasis__svHZV","noticeArea":"notice_noticeArea__eTa6v","title":"notice_title__kroFp","message":"notice_message__jx6_j"};